module.exports = __webpack_public_path__ + "media/choose_pic.f2009cb2.mp3";